import React from "react";
import { MessageCircle } from "lucide-react";
import { resellerPackages, resellerWaLink, packageMessage, brl, MIN_CREDITS } from "../../data/reseller";

const BASE = resellerPackages[0].price / resellerPackages[0].credits;
const savings = (pkg) => Math.round((1 - pkg.price / pkg.credits / BASE) * 1000) / 10;

const PackageCard = ({ pkg }) => (
  <div
    data-testid={`reseller-package-card-${pkg.credits}`}
    className={`relative overflow-hidden rounded-3xl border p-7 flex flex-col bg-surface/70 transition hover:-translate-y-1 ${
      pkg.highlight ? "border-brand-2/60 shadow-2xl shadow-brand/25" : "border-white/10 hover:border-white/25"
    }`}
  >
    {pkg.highlight && <div className="absolute inset-x-0 top-0 h-1 rounded-t-3xl bg-brand-gradient" />}
    <span className={`self-start px-3 py-1 rounded-full text-[11px] font-bold uppercase tracking-wider ${pkg.highlight ? "bg-brand-gradient text-white" : "bg-white/5 border border-white/10 text-silver"}`}>
      {pkg.badge}
    </span>
    <p className="mt-6 text-5xl font-extrabold tabular-nums">{pkg.credits}</p>
    <p className="text-sm text-silver/70 font-semibold uppercase tracking-widest">créditos</p>
    <div className="mt-6 flex items-end gap-1">
      <span className="text-silver/60 font-semibold pb-1">R$</span>
      <span data-testid={`reseller-package-price-${pkg.credits}`} className="text-4xl font-extrabold tabular-nums">{brl(pkg.price)}</span>
    </div>
    <p className="mt-1 text-xs text-brand-2 font-semibold">R$ {brl(pkg.price / pkg.credits)} por crédito</p>
    {savings(pkg) > 0 && (
      <span data-testid={`reseller-package-savings-${pkg.credits}`} className="mt-3 self-start px-2.5 py-1 rounded-md bg-brand-3/15 border border-brand-3/40 text-brand-3 text-xs font-bold">
        Economize {savings(pkg).toLocaleString("pt-BR")}%
      </span>
    )}
    <div className="flex-1 min-h-[1.75rem]" />
    <a
      href={resellerWaLink(packageMessage(pkg.credits, pkg.price))}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`reseller-package-${pkg.credits}`}
      className={`inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full font-bold text-sm transition ${
        pkg.highlight ? "bg-brand-gradient text-white shadow-lg shadow-brand/30 hover:brightness-110" : "bg-white/8 hover:bg-white/15 border border-white/15 text-white"
      }`}
    >
      <MessageCircle className="w-4 h-4" /> Quero este pacote
    </a>
  </div>
);

export const ResellerPackages = () => (
  <section id="pacotes" className="max-w-[1300px] mx-auto px-5 md:px-6 py-16 scroll-mt-20">
    <h2 className="text-3xl md:text-4xl font-extrabold tracking-tight">
      Pacotes de <span className="brand-gradient-text">créditos</span>
    </h2>
    <p className="mt-3 text-silver/75 max-w-2xl">Pagamento via PIX. Quanto maior o pacote, menor o custo por crédito.</p>
    <p data-testid="reseller-min-credits" className="mt-4 inline-flex items-center px-4 py-2 rounded-full bg-white/5 border border-white/10 text-sm font-semibold text-white">
      Mínimo por recarga: <span className="ml-1 brand-gradient-text">{MIN_CREDITS} créditos</span>
    </p>
    <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
      {resellerPackages.map((p) => <PackageCard key={p.credits} pkg={p} />)}
    </div>
  </section>
);
